import SignUpPageLayout from "../layouts/SignUpPageLayout";
import SignUpFlowForm from "../components/global/forms/SignUpFlow";

function SignUpPage(): JSX.Element {
  return (
    <SignUpPageLayout pageTitle="CSTL | Sign Up">
      <SignUpFlowForm />
    </SignUpPageLayout>
  );
}

export default SignUpPage;
